export default {
  'paymentFraudControlGrid.actions': 'Actions',
  'paymentFraudControlGrid.checkNumber': 'Check Number',
  'paymentFraudControlGrid.itemStatus': 'Item Status',
  'paymentFraudControlGrid.paidDate': 'Paid Date',
  'paymentFraudControlGrid.paidAmount': 'Paid Amount',
  'paymentFraudControlGrid.payeeInfo': 'Payee info',
  'paymentFraudControlGrid.issueDate': 'Issue Date',
  'paymentFraudControlGrid.issueAmount': 'Issue Amount',
  'paymentFraudControlGrid.exceptionReason': 'Exception Reason',
  'paymentFraudControlGrid.instruction': 'Instruction',
  'paymentFraudControlGrid.returnReason': 'Return Reason',
  'paymentFraudControlGrid.noRecordsFound': 'No records found',
  'paymentFraudControlGrid.lastModifiedUser': 'Last Modified User',
  'paymentFraudControlGrid.lastModifiedTime': 'Last Modified Time',
  'paymentFraudControlGrid.traceNumber': 'Trace Number',
  'paymentFraudControlGrid.sequenceNumber': 'Sequence Number',
  'paymentFraudControlGrid.dispositioned': 'Dispositioned',
  'paymentFraudControlGrid.notDispositioned': 'Not Dispositioned',
  'paymentFraudControlGrid.null': '--',
  'paymentFraudControlGrid.pleaseSelect': 'Please select an item from the list.',

  'paymentFraudControlGrid.notAvailable.APPROVE': 'Some items are not available to Approve',
  'paymentFraudControlGrid.notAvailable.PAY': 'Some items are not available to Pay',
  'paymentFraudControlGrid.notAvailable.PAY_AND_ISSUE':
    'Some items are not available to Pay And Issue',
  'paymentFraudControlGrid.notAvailable.PAY_AS_ISSUED':
    'Some items are not available to Pay As Issued',
  'paymentFraudControlGrid.notAvailable.REJECT': 'Some items are not available to Reject',
  'paymentFraudControlGrid.notAvailable.RETURN': 'Some items are not available to Return',
  'paymentFraudControlGrid.pendingModalHeader': 'Previously dispositioned items',
  'paymentFraudControlGrid.pendingModalSubHeader':
    'You are about to change item(s) previously decisioned:'
};
